import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { CustomTooltip } from '@/lib/dashboard-utils.jsx';

export const EngagementCharts = ({ engagementData, activityData }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-testid="charts-section">
    <div className="chart-container p-6 rounded-lg" data-testid="engagement-chart">
      <h2 className="text-xl font-semibold text-[#00d1ff] mb-4">ENGAGEMENT BY TEAM</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={engagementData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1a1a1a" />
          <XAxis dataKey="name" stroke="#666" tick={{ fill: '#999', fontSize: 11 }} angle={-45} textAnchor="end" height={80} />
          <YAxis stroke="#666" tick={{ fill: '#999' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ color: '#999' }} />
          <Bar dataKey="photos" fill="#00ff41" name="Photos" radius={[4, 4, 0, 0]} />
          <Bar dataKey="quizzes" fill="#00d1ff" name="Quizzes" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
    <div className="chart-container p-6 rounded-lg" data-testid="activity-chart">
      <h2 className="text-xl font-semibold text-[#00d1ff] mb-4">ACTIVITY PULSE (7 DAYS)</h2>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={activityData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1a1a1a" />
          <XAxis dataKey="date" stroke="#666" tick={{ fill: '#999' }} />
          <YAxis stroke="#666" tick={{ fill: '#999' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ color: '#999' }} />
          <Line type="monotone" dataKey="uploads" stroke="#00ff41" strokeWidth={3} dot={{ fill: '#00ff41', r: 4 }} name="Uploads" />
          <Line type="monotone" dataKey="quizzes" stroke="#00d1ff" strokeWidth={3} dot={{ fill: '#00d1ff', r: 4 }} name="Quizzes" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);
